import React from "react";
import { getYoutubeId, getVimeoId, getMatterportId } from "@wrstudios/utils";
import { IconMapPin, IconPhoto, IconVideo, IconRotate } from "@wrstudios/icons";
import { Container, Exit, Address, Street, CityStateZip, Controls, Grid, Cell, Control, ControlLabel } from "./styled/header";
function Header(_a) {
    var street = _a.street, city = _a.city, state = _a.state, zip = _a.zip, _b = _a.activeTab, activeTab = _b === void 0 ? "map" : _b, setActiveTab = _a.setActiveTab, _c = _a.controlColor, controlColor = _c === void 0 ? "#003c9f" : _c, virtualTour = _a.virtualTour, _d = _a.exitIcon, exitIcon = _d === void 0 ? (React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.53 3.47a.75.75 0 010 1.06L8.06 10l5.47 5.47a.75.75 0 11-1.06 1.06L5.94 10l6.53-6.53a.75.75 0 011.06 0z" }))) : _d, onExit = _a.onExit, hasPhotos = _a.hasPhotos, hasVirtualTour = _a.hasVirtualTour;
    var youtubeId = getYoutubeId(virtualTour || "");
    var vimeoId = getVimeoId(virtualTour || "");
    var matterportId = getMatterportId(virtualTour || "");
    var cityStateZip = [[city, state].filter(Boolean).join(", "), zip]
        .filter(Boolean)
        .join(" ");
    return (React.createElement(Container, null,
        React.createElement(Exit, { onClick: onExit }, exitIcon),
        street && (React.createElement(Address, { title: street + " " + cityStateZip },
            React.createElement(Street, null, street),
            React.createElement(CityStateZip, null, cityStateZip))),
        React.createElement(Controls, null,
            React.createElement(Grid, null,
                React.createElement(Cell, null,
                    React.createElement(Control, { controlColor: controlColor, isActive: activeTab === "map", onClick: function () { return setActiveTab("map"); } },
                        React.createElement(IconMapPin, null),
                        " ",
                        React.createElement(ControlLabel, null, "Map"))),
                hasPhotos && (React.createElement(Cell, null,
                    React.createElement(Control, { controlColor: controlColor, isActive: activeTab === "photos", onClick: function () { return setActiveTab("photos"); } },
                        React.createElement(IconPhoto, null),
                        " ",
                        React.createElement(ControlLabel, null, "Photos")))),
                hasVirtualTour && (React.createElement(Cell, null,
                    (youtubeId || vimeoId) && (React.createElement(Control, { controlColor: controlColor, isActive: activeTab === "tour", onClick: function () { return setActiveTab("tour"); } },
                        React.createElement(IconVideo, null),
                        " ",
                        React.createElement(ControlLabel, null, "Video"))),
                    matterportId && (React.createElement(Control, { controlColor: controlColor, isActive: activeTab === "tour", onClick: function () { return setActiveTab("tour"); } },
                        React.createElement(IconRotate, null),
                        " ",
                        React.createElement(ControlLabel, null, "360\u00B0"))),
                    !youtubeId && !vimeoId && !matterportId && virtualTour && (React.createElement(Control, { as: "a", target: "_blank", href: virtualTour, controlColor: controlColor, isExternal: true, isActive: activeTab === "tour" },
                        React.createElement(IconRotate, null),
                        " ",
                        React.createElement(ControlLabel, null, "Virtual Tour")))))))));
}
Header.defaultProps = {
    controlColor: "#003c9f",
    virtualTour: "",
    exitIcon: (React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.53 3.47a.75.75 0 010 1.06L8.06 10l5.47 5.47a.75.75 0 11-1.06 1.06L5.94 10l6.53-6.53a.75.75 0 011.06 0z" })))
};
export default Header;
